<template>
  <div v-bind:class="['indexList', type, toutiaoType?'toutiaoList':'']" v-if="indexList.length > 0">
    <!-- 如果你后续需要找到当前实例化后的swiper对象以对其进行一些操作的话，可以自定义配置一个ref属性 -->
    <div class="container">
      <div v-if="type == 'hot' && !toutiaoType" class="mainTitle hot"></div>
      <div v-if="type == 'hot' && toutiaoType" class="mainTitle toutiao"></div>
      <div v-if="type == 'new'" class="mainTitle new"></div>

      <div v-if="type == 'hot' && !toutiaoType" class="sceTitle">不容错过的精彩测评</div>
      <div v-if="type == 'new'" class="sceTitle">用新的视角遇见更好的自己</div>

      <component :is="swiper" :options="swiperOption" v-if="loadReady">
        <!-- 幻灯内容 -->
        <component
          :is="swiperSlide"
          v-for="item in indexList"
          :key="item.scalePoolId"
        >
          <v-touch v-on:tap="testTap(item)" class="swiperCont">
            <div class="imgCont">
              <span
                v-if="!!item.viewPromotionStyle"
                class="promotion-brand"
              ></span>
              <img v-bind:src="item.introPicture"/>
              <i
                v-if="(!isOldVip || item.vipBuyType !== 2) && !toutiaoType && !isHideVipEntrance" 
                class="vip-sign"
                :class="{'is-half': item.vipBuyType === 1}"
              ></i>
              <div v-if="type == 'hot' && !toutiaoType" class="testedPeople">
                {{ cutNum(item.count, 4) }}人已测
              </div>
              <div v-if="type == 'new'" class="testedPeople">
                {{ timeTransform(item.updateTime) }}
              </div>
              <p class="title"></p>
            </div>
            <div class="desc">
              {{ item.name }}
            </div>
            <div class="info">
              <template v-if="!hidePrice">
                <span
                  class="fs-14"
                  v-bind:class="[
                    'price',
                    !!item.viewPromotionStyle ? 'promotion' : ''
                  ]"
                >&yen;{{ Number(item.discountPrice).toFixed(2) }}</span>
                <!-- <span
                  class="price fs-14 old-price"
                  v-if="!!item.viewPromotionStyle"
                >￥{{ item.originalPrice.toFixed(2) }}</span> -->
              </template>
            </div>
            <div class="status" v-if="item.recommended">
              {{item.recommended}}人已推
            </div>
          </v-touch>
        </component>
      </component>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
// import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'
import {cutNum} from '../../../lib/units'

export default {
  name: 'indexList',
  /*components: {
            swiper,
            swiperSlide
        },*/
  props: ['indexList', 'type', 'anchorTag', 'toutiaoType', 'hidePrice'],
  computed: {
    ...mapState(['channelId']),
    isItemDescTwoLine () {
      const that = this
      let result = 0
      that.indexList.map(item => {
        if (item.name.length > 8) {
          result++
        }
      })
      return !!(result > 0)
    }
  },
  data () {
    return {
      swiper: null,
      swiperSlide: null,
      loadReady: false,
      swiperOption: {
        autoplay: 0,
        slidesPerView: 'auto',
        paginationClickable: true,
        loop: false
      }
    }
  },
  mounted () {
    if (this.anchorTag != '') {
      let anchorEl = document.querySelector('.indexList.' + this.anchorTag)
      if (anchorEl == undefined) {
        return
      } else {
        document.body.scrollTop = anchorEl.offsetTop
      }
    }
  },
  methods: {
    ...mapMutations(['setINDEXSCROLLTOP']),
    cutNum,
    timeTransform (time) {
      if ((time == '') | (time == undefined)) {
        return ''
      }
      let rs = ''
      let thatDay = new Date(time.replace(/-/g, '/'))
      let today = new Date()
      let c0 = function (num) {
        return num * 1 < 10 ? '0' + num : num
      }
      if (
        (today.getFullYear() == thatDay.getFullYear()) &
        (today.getMonth() == thatDay.getMonth()) &
        (today.getDate() == thatDay.getDate())
      ) {
        if (today.getHours() == thatDay.getHours()) {
          return c0(today.getMinutes()) - c0(thatDay.getMinutes()) + '分钟前'
        } else {
          return c0(thatDay.getHours()) + ':' + c0(thatDay.getMinutes())
        }
      } else {
        return c0(thatDay.getMonth() + 1) + '-' + c0(thatDay.getDate())
      }
      return rs
    },
    testTap (testObj) {
      this.$emit('testClick', testObj, this.type)
      // 微站-测评大厅-热卖爆款-查看热卖测评 神策埋点
      this.$wechatTrackEvent('weizhan_cepinghome_checkhottest', {
        test_id: testObj.scalePoolId,
        test_name: testObj.name,
      });
    }
  },

  // 如果日后vue-awesome-swiper用的多，可以考虑分离出一个mixins
  // swiper: null,
  // swiperSlide: null,
  // loadReady: false,
  created () {
    domReadyPr
      .then(() => import('vue-awesome-swiper'))
      .then(({swiper, swiperSlide}) => {
        this.loadReady = true
        this.swiper = swiper
        this.swiperSlide = swiperSlide
      })
  }
}
</script>

<style lang="scss">
  @import '../../../scss/function';

  @mixin limitLine($line) {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: $line;
  }

  .indexList {
    position: relative;
    overflow: hidden;

    .container {
      margin: topx(30rem) 0 0 topx(30rem);
    }

    .mainTitle {
      margin-bottom: topx(10rem);

      &.hot {
        width: topx(208rem);
        height: topx(46rem);
        background: url('../../../assets/show/indexTitle/indexTitle_hot.png') no-repeat;
        background-size: cover;
      }

      &.new {
        width: topx(253rem);
        height: topx(45rem);
        background: url('../../../assets/show/indexTitle/indexTitle_new.png') no-repeat;
        background-size: cover;
      }

      &.toutiao {
        width: topx(203rem);
        height: topx(78rem);
        background: url('../../../assets/toutiao/indexTitle-toutiao.png') no-repeat;
        background-size: 100% 100%;
        margin-bottom: topx(19rem);
      }
    }

    .sceTitle {
      margin-bottom: topx(20rem);
      font-size: topx(24rem);
      color: #999999;
      line-height: 1.1;
    }

    .swiper-container {
      margin-left: topx(-10rem);
      // margin-right: topx(20rem);
      .swiper-slide {
        width: topx(216rem);
        background: #fff;
        border: 1px solid #f0f0f0;
        border-radius: topx(10rem);
        margin-right: topx(15rem);
        height: topx(318rem);

        &:first-child {
          margin-left: topx(0rem);
        }

        &:last-child {
          margin-right: topx(15rem);
        }
      }

      .swiperCont {
        display: block;
        width: topx(216rem);
        margin: topx(15rem) topx(15rem) 0 topx(15rem);

        .imgCont {
          position: relative;
          width: topx(183rem);
          height: topx(183rem);
          box-sizing: border-box;
          overflow: hidden;
          margin-bottom: topx(8rem);
          border-radius: topx(4rem);

          img {
            width: 100%;
            height: 100%;
          }

          .promotion-brand {
            position: absolute;
            z-index: 2;
            top: topx(10rem);
            left: topx(10rem);
            width: topx(40rem);
            height: topx(40rem);
            background: url('../../../assets/promotion/icon-brand.svg') no-repeat;
            background-size: cover;
          }

          .titleMask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.3;
            background: #000;
          }
        }

        .desc {
          font-weight: bold;
          text-align: left;
          // @include limitLine(2);
          font-size: topx(26rem);
          color: #333333;
          letter-spacing: 0.13px;
          line-height: topx(32rem);
          min-height: topx(64rem);
          width: topx(188rem);
        }

        .info {
          overflow: hidden;
          font-size: 0;
          margin-top: topx(6rem);

          .price {
            float: left;
            color: #ffa800;
            line-height: 1;
            font-weight: bold;

            &.promotion {
              color: #ff755b;
            }

            &.old-price {
              margin-left: topx(10rem);
              text-decoration: line-through;
              font-size: 10px;
              color: #999999;
            }
          }

          .right {
            float: right;
            font-size: 20px * 0.5;
            color: #999999;
            line-height: 28px * 0.5;
          }
        }

        .testedPeople {
          font-size: topx(20rem);
          color: #ffffff;
          line-height: topx(20rem);
          position: absolute;
          width: topx(150rem);
          height: topx(20rem);
          left: topx(10rem);
          bottom: topx(10rem);
        }
      }
    }

    .icon_vip {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .toutiaoList {
    .swiper-container {
      z-index: 0;
      .swiper-slide {
        border: 0;
      }
    }

    .swiper-container .swiper-slide {
      height: auto;
    }

    .swiper-container .swiperCont{
      .desc {
        min-height: topx(32rem);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .info {
        margin-top: topx(10rem);
      }
      .status {
        margin: topx(20rem) 0;
        font-size: topx(24rem);
        color: #999999;
        line-height: topx(24rem);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/show/index/testSwiper.vue